import React from 'react';

const PostCard = ({ title, date, description, image, link }) => {
  // format date to month date, year

  const dateFormatted = date ? new Date(date).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  }) : "";

  return (
    <div className="card" style={{ position: 'relative' }}>
      {/* if there is no image show default placeholder */}
      {image ? (
        <div style={{ backgroundImage: `url(${image})`, height: '250px' }} />
      ) : (
        // create div with default placeholder gray background and height of 250px
        <div style={{ backgroundColor: '#eaeaea', height: '250px' }} />
        // <div className="card-image" style={{ backgroundColor: "#f5f5f5" }} />
      )}
      <div className="card-body">
        <h5 className="card-title">{title}</h5>
        <p>{dateFormatted}</p>
        <p className="card-text">{description}</p>
        <a href={link} className="btn btn-primary">
          Read More
        </a>
      </div>
    </div>
  );
};

export default PostCard;
